var _rect, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 270,
    viewBox: "0 0 512 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10711_6691)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10711_6691",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: -160,
    width: 480,
    height: 480
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    transform: "translate(16 -160)",
    fill: "url(#paint0_radial_10711_6691)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10711_6691)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10711_6691)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10711_6691)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: -160,
    x2: 16.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.5,
    y1: -160,
    x2: 48.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.5,
    y1: -160,
    x2: 80.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.5,
    y1: -160,
    x2: 112.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.5,
    y1: -160,
    x2: 144.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.5,
    y1: -160,
    x2: 176.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.5,
    y1: -160,
    x2: 208.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.5,
    y1: -160,
    x2: 240.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.5,
    y1: -160,
    x2: 272.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.5,
    y1: -160,
    x2: 304.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.5,
    y1: -160,
    x2: 336.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.5,
    y1: -160,
    x2: 368.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.5,
    y1: -160,
    x2: 400.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.5,
    y1: -160,
    x2: 432.5,
    y2: 320,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.5,
    y1: -160,
    x2: 464.5,
    y2: 320,
    stroke: "#EAECF0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: -159.5,
    width: 479,
    height: 479,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 31.5,
    x2: 496,
    y2: 31.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 63.5,
    x2: 496,
    y2: 63.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 95.5,
    x2: 496,
    y2: 95.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 127.5,
    x2: 496,
    y2: 127.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 159.5,
    x2: 496,
    y2: 159.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 191.5,
    x2: 496,
    y2: 191.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 223.5,
    x2: 496,
    y2: 223.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 255.5,
    x2: 496,
    y2: 255.5,
    stroke: "#EAECF0"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 80,
    r: 80,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 20,
    r: 8,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 126,
    r: 6,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 138,
    r: 10,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 38,
    r: 10,
    fill: "#F2F4F7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 337,
    cy: 11,
    r: 7,
    fill: "#F2F4F7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_10711_6691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.079 124.215L254.531 99.7561C257.164 98.5281 258.303 95.3978 257.075 92.7643L226.1 26.337L205.124 18.7026L162.21 38.714C159.576 39.942 158.437 43.0723 159.665 45.7058L195.087 121.67C196.315 124.303 199.446 125.443 202.079 124.215Z",
    fill: "url(#paint1_linear_10711_6691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.125 18.7031L226.1 26.3375L211.795 33.008L205.125 18.7031Z",
    fill: "#D0D5DD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_10711_6691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.152 106.339H285.025C287.931 106.339 290.287 103.984 290.287 101.078V27.7837L274.503 12H227.152C224.246 12 221.891 14.3555 221.891 17.2612V101.078C221.891 103.984 224.246 106.339 227.152 106.339Z",
    fill: "url(#paint2_linear_10711_6691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.504 12L290.288 27.7837H274.504V12Z",
    fill: "#D0D5DD"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_10711_6691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.912 99.724L309.364 124.182C311.997 125.41 315.127 124.271 316.356 121.638L347.331 55.2103L339.697 34.2349L296.782 14.2235C294.149 12.9955 291.018 14.1348 289.79 16.7683L254.368 92.7322C253.14 95.3657 254.279 98.496 256.912 99.724Z",
    fill: "url(#paint3_linear_10711_6691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.697 34.2344L347.332 55.2098L333.027 48.5393L339.697 34.2344Z",
    fill: "#D0D5DD"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_10711_6691)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 89,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 108.25V125.75M264.75 117H247.25",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_10711_6691",
    x: 137.441,
    y: 12.0312,
    width: 141.857,
    height: 154.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_10711_6691",
    result: "effect2_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_10711_6691",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_10711_6691",
    x: 201.891,
    y: 12,
    width: 108.396,
    height: 134.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_10711_6691",
    result: "effect2_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_10711_6691",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_10711_6691",
    x: 232.145,
    y: 12,
    width: 141.857,
    height: 154.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_10711_6691",
    result: "effect2_dropShadow_10711_6691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_10711_6691",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_10711_6691",
    x: 220,
    y: 81,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10711_6691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10711_6691",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10711_6691",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240 240) rotate(90) scale(240 240)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10711_6691",
    x1: 198.998,
    y1: 124.419,
    x2: 157.198,
    y2: 49.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10711_6691",
    x1: 224.273,
    y1: 105.223,
    x2: 218.259,
    y2: 19.2131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10711_6691",
    x1: 254.775,
    y1: 97.4951,
    x2: 285.674,
    y2: 17.0024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10711_6691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 270,
    fill: "white",
    transform: "translate(16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10711_6691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    fill: "white",
    transform: "translate(16 -160)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10711_6691"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: -160,
    width: 480,
    height: 480,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.13b11a79137271802af35c0476aaddce.svg";
export { ForwardRef as ReactComponent };